export const initWpSwipers = () => {
  const wpSwiperContainers = document.querySelectorAll('.wp-swiper .swiper-container');

  if (wpSwiperContainers.length === 0) {
    return;
  }

  class WpSwiperInstance {
    constructor(container) {
      this.container = container;
      this.parentWidth = 0;
      this.swiper = null;
      this.slidesPerView = 1; // Default value
      this.init();
    }

    findParent() {
      // Start from the .swiper parent (which is .wp-swiper), not the .swiper-container
      let parent = this.container.parentElement ? this.container.parentElement.parentElement : null;
      // Look for parent with "wp-block" in the classname
      while (parent) {
        if (parent.classList && Array.from(parent.classList).some(cls => cls.includes('wp-block'))) {
          return parent;
        }
        parent = parent.parentElement;
      }
      // If no wp-block parent found, look for content containers
      const contentParent = document.querySelector('.content') || document.querySelector('#blog-content') || document.body;
      return contentParent;
    }

    updateWidth(parentWidth) {
      const viewportWidth = window.innerWidth;
      
      // Check if this swiper is inside a wp-block-columns
      const isInColumns = this.container.closest('.wp-block-columns') !== null;
      
      let effectiveMaxWidth;
      
      if (isInColumns) {
        // For swipers in columns, use the column's actual width
        const column = this.container.closest('.wp-block-column');
        if (column) {
          const columnRect = column.getBoundingClientRect();
          effectiveMaxWidth = columnRect.width;
        } else {
          effectiveMaxWidth = parentWidth;
        }
      } else {
        // For full-width swipers (not in columns)
        const blogContent = document.getElementById('blog-content');
        const contentElement = document.querySelector('.content');
        
        if (blogContent && contentElement) {
          const contentRect = contentElement.getBoundingClientRect();
          effectiveMaxWidth = contentRect.width;
        } else if (parentWidth > 0) {
          // Use parent width if it's valid
          effectiveMaxWidth = parentWidth;
        } else {
          // Fallback to viewport width minus reasonable padding
          const padding = 40; // 20px on each side
          effectiveMaxWidth = Math.max(viewportWidth - padding, 300); // Minimum 300px width
        }
      }
      
      // Apply width to the wrapper for layout purposes
      const wrapper = this.container.closest('.wp-swiper__wrapper');
      if (wrapper) {
        wrapper.style.width = `${effectiveMaxWidth}px`;
        wrapper.style.maxWidth = `${effectiveMaxWidth}px`;
      }
      
      // CRITICAL: Apply the same width to the swiper container itself
      this.container.style.width = `${effectiveMaxWidth}px`;
      this.container.style.maxWidth = `${effectiveMaxWidth}px`;
      
      // Remove inline styles from slides, container, and wrapper - let Swiper calculate based on container
      const slides = this.container.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        // Use !important to override any existing inline styles
        slide.style.setProperty('width', '', 'important');
        slide.style.setProperty('max-width', '', 'important');
      });
      
      // Also remove width/max-width from the swiper container itself
      this.container.style.setProperty('width', '', 'important');
      this.container.style.setProperty('max-width', '', 'important');
      
      // Also remove width/max-width from the wp-swiper__wrapper
      const swiperWrapper = this.container.closest('.wp-swiper__wrapper');
      if (swiperWrapper) {
        swiperWrapper.style.setProperty('width', '', 'important');
        swiperWrapper.style.setProperty('max-width', '', 'important');
      }

      // Force Swiper to recalculate
      if (this.swiper) {
        this.swiper.update();
      }
    }

    init() {
      const parent = this.findParent();
      if (!parent) {
        console.error('Could not find parent with wp-block class for container:', this.container);
        return;
      }

      // Check if in a column layout
      const column = this.container.closest('.wp-block-column');
      const observeTarget = column || parent; // Observe the column if it exists

      const handleResize = (entries) => {
        for (let entry of entries) {
          const { width } = entry.contentRect;
          this.updateWidth(width);
        }
      };

      this.resizeObserver = new ResizeObserver(handleResize);
      this.resizeObserver.observe(observeTarget);

      // Manually trigger the first update with the correct width
      const initialWidth = observeTarget.offsetWidth;
      this.updateWidth(initialWidth);

      const config = JSON.parse(this.container.dataset.swiper);

      this.slidesPerView = parseInt(config.slidesPerView);
      const slidesPerView = this.slidesPerView;

      // If slidesPerView is 1, set it to 'auto' in the config to allow CSS control over slide width.
      // This prevents Swiper from applying fixed widths (like 500px) inline.
      if (slidesPerView === 1) {
        config.slidesPerView = 'auto';
      }

      const breakpointConfig = (slidesPerView > 1 && !config.breakpoints) ? {
        breakpoints: {
          1024: {
            slidesPerView: slidesPerView
          },
          768: {
            slidesPerView: Math.min(3, slidesPerView)
          },
          640: {
            slidesPerView: Math.min(2, slidesPerView)
          },
          320: {
            slidesPerView: 1
          }
        }
      } : {};

      this.swiper = new window.Swiper(this.container, {
        // modules are already configured in app.js via Swiper.use()
        ...config,
        ...breakpointConfig,
        navigation: config.navigation ? {
          nextEl: this.container.parentElement.querySelector('.swiper-button-next'),
          prevEl: this.container.parentElement.querySelector('.swiper-button-prev')
        } : false,
        pagination: config.pagination ? {
          el: this.container.parentElement.querySelector('.swiper-pagination'),
          ...config.pagination
        } : false
      });
    }

    destroy() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  const instances = [];

  wpSwiperContainers.forEach(container => {
    try {
      const instance = new WpSwiperInstance(container);
      instances.push(instance);
    } catch (error) {
      console.error('Error initializing WP Swiper:', error);
      console.error('Container:', container);
      console.error('Error details:', error);
    }
  });

  // Clean up instances on page unload
  window.addEventListener('beforeunload', () => {
    instances.forEach(instance => {
      instance.destroy();
    });
  });
};